<template>
  <div v-if="showModal" class="modal-overlay" @click.self="closeModal">
    <div class="modal-content" @click="showResidualFee">
      <span class="close-button" @click="closeModal">&times;</span>
      <div class="success-icon">
        <img src="@/assets/cardRegistered.svg" alt="成功" />
      </div>
      <h2>新增信用卡成功</h2>
      <p>將重新回到信用卡登記頁面</p>
    </div>
  </div>
</template>

<script>
export default {
  data() {
    return {
      showModal: true
    };
  },
  methods: {
    closeModal() {
      // this.showModal = false;
      console.log('close RegisterCard Sucess Modal');
      this.$emit('close');
    },
    showResidualFee() {
      this.$emit('show-residual-fee');
    }
  }
};
</script>

<style scoped>
.modal-overlay {
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background-color: rgba(0, 0, 0, 0.5);
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: flex-start;
  z-index: 1000;
}

.modal-content {
  position: relative;

  background-color: white;
  border-radius: 10px;
  width: 480px;
  height: 400px;
  /* padding: 24px 30px; */
  padding: 0px;
  box-sizing: border-box;

  margin-top: 80px;


}

.close-button {
  position: absolute;


  width: 24px;
  height: 24px;
  top: 32px;
  left: 424px;

  /* //styleName: 2xl/regular; */
  font-family: Inter;
  font-size: 28px;

  cursor: pointer;
  color: black;
}


.success-icon {
  position: absolute;

  width: 137px;
  height: 93.5px;
  top: 73px;
  left: 171px;


}

.success-icon img {
  width: 100%;
  height: 100%;
  object-fit: contain;
}





h2 {

  position: absolute;

  width: 224px;
  height: 44px;
  top: 220px;
  left: 128px;

  /* //styleName: 4xl/bold; */
  font-family: Inter;
  font-size: 32px;
  font-weight: 700;
  line-height: 43.52px;
  text-align: center;
  text-underline-position: from-font;
  text-decoration-skip-ink: none;



  color: var(--green03);
  /* margin-top: 0; */
  /* margin-bottom: 10px; */
}

p {

  position: absolute;
  width: 240px;
  height: 30px;
  top: 280px;
  left: 120px;


  /* //styleName: xl/regular; */
  font-family: Inter;
  font-size: 20px;
  font-weight: 400;
  line-height: 30px;
  text-align: center;
  text-underline-position: from-font;
  text-decoration-skip-ink: none;

  color: var(--gray15);

}

/* Responsive Styles */
@media (max-width: 560px) {
  .modal-content {
    width: 343px;
    height: 304px;
    /* height: auto; */
  }

  .success-icon {
    width: 95px;
    height: 64.84px;
    top: 42px;
    left: 124px;

  }

  h2 {
    width: 168px;
    height: 34px;
    top: 152px;
    left: 88px;
    gap: 0px;
    opacity: 0px;

    /* //styleName: 2xl/bold; */
    font-family: Inter;
    font-size: 24px;
    font-weight: 700;
    line-height: 33.6px;
    text-align: center;
    text-underline-position: from-font;
    text-decoration-skip-ink: none;


  }

  p {
    width: 272px;
    height: 22px;
    top: 202px;
    left: 36px;


    /* //styleName: sm/regular; */
    font-family: Inter;
    font-size: 14px;
    font-weight: 400;
    line-height: 21.56px;
    text-align: center;
    text-underline-position: from-font;
    text-decoration-skip-ink: none;



  }

  .close-button {
    width: 20px;
    height: 20px;
    top: 20px;
    left: 299px;

  }
}
</style>
